import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import { BaseButton } from '../../../../BaseComponents';
import { CdnIcon } from '@shared/ui';

interface ClassNameMap {
	backButton?: string;
	continueButton?: string;
	wrapper?: string;
}

export interface FooterMobileProps {
	onBack?: () => void;
	onContinue?: () => void;
	backButtonText?: string;
	continueButtonText?: string;
	disabled?: boolean;
	className?: string;
	classes?: ClassNameMap;
	left?: React.ReactElement;
	right?: React.ReactElement;
	children?: React.ReactElement;
}

const FooterMobile = React.forwardRef<HTMLDivElement, FooterMobileProps>(
	(
		{ onBack, onContinue, backButtonText, continueButtonText, disabled, className, classes, left, right, children },
		ref
	) => {
		const { FooterMobile: css } = useTheme('Shared');
		const { t } = useTranslation('MobileToolbar');

		return (
			<div ref={ref} className={cn(css.wrapper, className, classes?.wrapper)} data-footer-mobile>
				{children}
				{left ?? !!onBack ? (
					<BaseButton
						variant="smallSecondary"
						className={cn(css.button, css.button_back, classes?.backButton, {
							[css.button_empty]: !backButtonText
						})}
						onClick={onBack}
					>
						{!!backButtonText ? backButtonText : <CdnIcon icon="Arrow/Back" />}
					</BaseButton>
				) : null}

				{right ?? typeof onContinue !== 'undefined' ? (
					<BaseButton
						type={onContinue ? 'button' : 'submit'}
						variant="smallPrimary"
						className={cn(css.button, css.button_continue, classes?.continueButton)}
						disabled={disabled}
						onClick={onContinue}
						data-next-button={true}
						data-test-id="footer-next"
					>
						{!!continueButtonText ? continueButtonText : t('Continue')}
					</BaseButton>
				) : null}
			</div>
		);
	}
);

FooterMobile.displayName = 'FooterMobile';

export default FooterMobile;
